import {useDashboardLayoutStore} from '../state/ui.js'

export function useDashboardLayout() {
    const layout = useDashboardLayoutStore(state => state.layout)
    const setLayout = useDashboardLayoutStore(state => state.setLayout)
    return {layout, setLayout}
}
